import { payrollOverviewDetailsStore } from './features/payroll-overviews-details/payroll-overview-details.store';
import { payrollOverviewsListingStore } from '@/app/features/payroll-overviews/features/payroll-overviews-listing/payroll-overviews-listing.store';
export const payrollOverviewsStore = {
  modules: {
    payrollOverviewDetailsState: payrollOverviewDetailsStore,
    payrollOverviewsListingState: payrollOverviewsListingStore
  }
};
